import React, { memo } from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { Testimonials } from '@fiverr-private/seller_pages_toolbox';
import { titleClass } from './RolePageTestimonials.ve.css';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the RolePageTestimonials Component');
    logger.error(err, {
        cause: originalError,
    });
};

export const RolePageTestimonials = memo(() => (
    <ErrorBoundary onError={onRenderError}>
        <Testimonials titleClassName={titleClass} />
    </ErrorBoundary>
));

RolePageTestimonials.displayName = 'RolePageTestimonials';
